import { useEffect, useState } from 'react';

export function usePeriodSelection(
  storageKey: string,
  options: readonly { value: number }[],
  defaultPeriod: number,
) {
  const [periodDays, setPeriodDays] = useState(() => {
    try {
      const stored = window.localStorage.getItem(storageKey);
      const parsed = stored?.trim() ? Number(stored) : NaN;
      return options.some((option) => option.value === parsed) ? parsed : defaultPeriod;
    } catch {
      return defaultPeriod;
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(storageKey, String(periodDays));
    } catch {
      // Period selection still works when browser storage is unavailable.
    }
  }, [storageKey, periodDays]);

  return [periodDays, setPeriodDays] as const;
}
